import React from "react";
import Loader from "../../../../loader/Loader";

const OverlayLoader = ({ className }) => {
  return (
    <div>
      <div
        className={`fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black z-[99999] ${className}`}
      >
        <Loader />
      </div>
    </div>
  );
};

export default OverlayLoader;
